<div class="@container/workarea">
    <div class="form-row">
        <div class="form-row-info">
            <h3 class="form-row-title">
                Size chart
            </h3>
            <p class="form-row-description">
                Size chart for this product
                <br /><span class="text-xs text-gray-300">{{localModel.reloadCount}}</span>
            </p>
        </div>
        <div class="form-row-field">
            @if (data != null && data.Message)
            {
                <span>{{data.Message}}</span>
            }
            <div>
                @if (data !== null && data.Logs !== null)
                {
                    <ul class="loglist">
                        @for(log of data.Logs; track $index)
                        {
                            <li>
                                @if(log.Type==0)
                                {
                                <div class="sizemapinfo"><i class="pim-icon pim-icon-info"></i> {{log.Message}}</div>
                                }
                                @else if(log.Type==1)
                                {
                                <div class="sizemapsuccess"><i class="pim-icon pim-icon-check"></i> {{log.Message}}</div>
                                }
                                @else if(log.Type==2)
                                {
                                <div class="sizemapwarning"><i class="pim-icon pim-icon-warning"></i> {{log.Message}}</div>
                                }
                                @else if (log.Type==3)
                                {
                                <div class="sizemaperror"><i class="pim-icon pim-icon-warning"></i> {{log.Message}}</div>
                                }
                            </li>
                        }                        
                    </ul>
                }
            </div>
            @if (data != null && data.TableData != null)
            {
            <table class="w-full text-sm text-left">
                <thead class="text-xs text-gray-700 uppercase bg-gray-50">
                    @if(data.Description[cultureName] != null)
                    {
                    <tr>
                        <th scope="col" class="px-6 py-3" [colSpan]="data.NumberOfColumns">
                            {{data.Description[cultureName]}}
                        </th>
                    </tr>
                    }
                    @for (row of data.TableData[cultureName]; track $index)
                    {
                        @if ($index < data.NumberOfHeaderRows)
                        {
                        <tr>
                            @for (col of row; track $index)
                            {
                                <th scope="col" class="px-6 py-3 min-w-48" [ngClass]="{'text-nowrap': $index > 0, 'min-w-48': $index == 0}">
                                    {{col}}
                                </th>
                            }
                        </tr>
                        }
                    }
                </thead>
                <tbody>
                    @for (row of data.TableData[cultureName]; track $index)
                    {
                        @if($index >= data.NumberOfHeaderRows)
                        {
                        <tr class="bg-white border-b border-gray-200">
                            @for (col of row; track $index)
                            {
                                <td scope="col" class="px-6 py-4" [ngClass]="{'text-nowrap': $index > 0}">{{col}}</td>
                            }
                        </tr>
                        }    
                    }                        
                </tbody>
            </table>
            }
        </div>
    </div>

    <hr class="border-gray-100 my-5">
</div>
